module.exports = __webpack_public_path__ + "resources/205c0a75321d91c1035bb7e7defb5ba7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/weakness.png
// module id = 232
// module chunks = 0